module.exports = __webpack_public_path__ + "img/shakeys_glass.ed95da5d.jpg";